"use client";

import { CheckIcon, WishlistIcon } from "@/components/appIcons";
import { useHydrated } from "@/hooks/use-hydrated";
import { cn } from "@/lib/utils";

type ChipSize = "default" | "compact";

interface CollectionStateChipProps {
  inCollection: boolean;
  inWishlist?: boolean;
  collectionLabel: string;
  wishlistLabel?: string;
  size?: ChipSize;
  className?: string;
}

function getCollectionClasses(size: ChipSize) {
  if (size === "compact") {
    return "flex items-center gap-0.5 px-1.5 py-0.5 bg-green-600/20 text-green-500 text-[10px] font-bold uppercase tracking-wider rounded";
  }

  return "flex items-center gap-1 px-2 py-0.5 bg-green-600/20 text-green-500 text-xs font-bold uppercase tracking-widest rounded";
}

function getWishlistClasses(size: ChipSize) {
  if (size === "compact") {
    return "flex items-center gap-0.5 px-1.5 py-0.5 bg-pink-600/20 text-pink-500 text-[10px] font-bold uppercase tracking-wider rounded";
  }

  return "flex items-center gap-1 px-2 py-0.5 bg-pink-600/20 text-pink-500 text-xs font-bold uppercase tracking-widest rounded";
}

function getIconSize(size: ChipSize) {
  if (size === "compact") {
    return "12px";
  }
  return "14px";
}

export function CollectionStateChip({
  inCollection,
  inWishlist = false,
  collectionLabel,
  wishlistLabel,
  size = "default",
  className,
}: CollectionStateChipProps) {
  const hydrated = useHydrated();

  if (hydrated && inCollection) {
    return (
      <span className={cn(getCollectionClasses(size), className)}>
        <CheckIcon style={{ fontSize: getIconSize(size) }} />
        {collectionLabel}
      </span>
    );
  }

  if (hydrated && inWishlist && wishlistLabel) {
    return (
      <span className={cn(getWishlistClasses(size), className)}>
        <WishlistIcon style={{ fontSize: getIconSize(size) }} />
        {wishlistLabel}
      </span>
    );
  }

  return null;
}
